export function requireLogin() {
  window.location.href = `/users/sign_in?redirect_to=${window.location.pathname}`;
}
